import App from './App';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { createAppStore } from './redux';
import { APPLICATION_CONTAINER_ID } from './constants';

const store = createAppStore(window.__initialState__);

hydrateRoot(
  document.getElementById(APPLICATION_CONTAINER_ID),
  <ReduxProvider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ReduxProvider>
);

if (module.hot) {
  module.hot.accept();
}
